<template>
  <div class="container">
    <div class="apply-tab">
      <img @click="onClickLeft" style="width: 24px; height: 24px" src="../assets/back.png" />
      <div>{{ title }}</div>
    </div>
    <van-form ref="form" @submit="onSubmit">
      <div class="peopleDeatail">
        <van-field readonly v-model="form.applicant" required :rules="[{ required: true }]" name="picker" label="申请人" placeholder="请选择" />

        <van-field
          v-if="approvalType === 1 && projshow"
          is-link
          readonly
          v-model="form.loanOwnershipName"
          required
          :rules="[{ required: true }]"
          name="picker"
          label="项目名称"
          placeholder="请选择"
          @click="loanAttributionPicker = true"
        />
        <van-popup v-model="loanAttributionPicker" position="bottom">
          <van-picker
            :columns="projectApprovalList"
            value-key="projectName"
            show-toolbar
            @confirm="
              value => {
                form.loanOwnershipName = value.projectName;
                form.loanOwnership = value.projectId;
                loanAttributionPicker = false;
                form.projectNo = value.projectNo;
              }
            "
            @cancel="loanAttributionPicker = false"
          />
        </van-popup>

        <van-field v-if="approvalType === 1 && form.loanOwnershipName" readonly v-model="form.projectNo" label="项目编码" placeholder="项目编码" />

        <van-field is-link readonly v-model="form.budgetName" required :rules="[{ required: true }]" name="picker" label="预算执行" placeholder="请选择" @click="budgetPicker = true" />
        <van-popup v-model="budgetPicker" position="bottom">
          <van-picker
            :columns="budgetList"
            value-key="label"
            show-toolbar
            @confirm="
              value => {
                form.budget = value.value;
                form.budgetName = value.label;
                budgetPicker = false;
              }
            "
            @cancel="budgetPicker = false"
          />
        </van-popup>

        <van-field
          v-if="approvalType === 1"
          is-link
          readonly
          v-model="form.expectedReturnDate"
          required
          :rules="[{ required: true }]"
          name="picker"
          label="预计归还日期"
          placeholder="请选择"
          @click="expectedReturnDatePicker = true"
        />
        <van-popup v-model="expectedReturnDatePicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            :min-date="minDate"
            :max-date="maxDate"
            type="date"
            @confirm="
              value => {
                form.expectedReturnDate = value ? $dayjs(value).format('YYYY-MM-DD') : null;
                expectedReturnDatePicker = false;
              }
            "
            @cancel="expectedReturnDatePicker = false"
          />
        </van-popup>
        <van-field is-link readonly v-model="form.billDate" required :rules="[{ required: true }]" name="picker" label="单据日期" placeholder="请选择" @click="billDatePicker = true" />
        <van-popup v-model="billDatePicker" position="bottom">
          <van-datetime-picker
            v-model="currentDate"
            :min-date="minDate"
            :max-date="maxDate"
            type="date"
            @confirm="
              value => {
                form.billDate = value ? $dayjs(value).format('YYYY-MM-DD') : null;
                billDatePicker = false;
              }
            "
            @cancel="billDatePicker = false"
          />
        </van-popup>

        <van-field
          v-if="approvalType !== 1 && projshow"
          is-link
          readonly
          v-model="form.costAttributionName"
          required
          :rules="[{ required: true }]"
          name="picker"
          label="项目名称"
          placeholder="请选择"
          @click="expensesAttributionPicker = true"
        />
        <van-popup v-model="expensesAttributionPicker" position="bottom">
          <van-picker
            :columns="projectApprovalList"
            value-key="projectName"
            show-toolbar
            @confirm="
              value => {
                form.costAttributionId = value.projectId;
                form.costAttributionName = value.projectName;
                form.projectNo = value.projectNo;
                getRelevanceLoan();
                expensesAttributionPicker = false;
              }
            "
            @cancel="expensesAttributionPicker = false"
          />
        </van-popup>

        <van-field v-if="approvalType !== 1 && form.costAttributionName" readonly v-model="form.projectNo" label="项目编码" placeholder="项目编码" />

        <van-field
          v-if="approvalType === 3"
          is-link
          readonly
          v-model="form.billTypeName"
          required
          :rules="[{ required: true }]"
          name="picker"
          label="单据类型"
          placeholder="请选择"
          @click="billTypePicker = true"
        />
        <van-popup v-model="billTypePicker" position="bottom">
          <van-picker
            :columns="billTypeList"
            value-key="label"
            show-toolbar
            @confirm="
              value => {
                form.billTypeName = value.label;
                form.billType = value.value;
                billTypePicker = false;
              }
            "
            @cancel="billTypePicker = false"
          />
        </van-popup>

        <!-- 付款申请单type=3支持选择单位类型 -->
        <van-field
          is-link
          v-if="approvalType === 3"
          readonly
          v-model="form.contactUnitTypeName"
          required
          :rules="[{ required: true }]"
          name="picker"
          label="往来单位类型"
          placeholder="请选择"
          @click="contactTypesPicker = true"
        />
        <!-- 类型列表 -->
        <van-popup v-model="contactTypesPicker" position="bottom">
          <van-picker
            ref="payUnitPicker"
            :columns="contactTypesList"
            value-key="value"
            show-toolbar
            @confirm="
              value => {
                form.contactUnitType = value.key;
                form.contactUnitTypeName = value.value;
                handleChange(form.contactUnitTypeName);
                contactTypesPicker = false;
              }
            "
            @cancel="contactTypesPicker = false"
          />
        </van-popup>

        <van-field
          :is-link="readonlyPayUnit"
          v-if="approvalType === 3"
          readonlyPayUnit
          v-model="form.contactCompany"
          required
          :rules="[{ required: true }]"
          label="往来单位"
          placeholder="请输入"
          @click="openCompanyPick"
        />
        <!-- 单位列表 -->
        <van-popup v-model="contactCompanyPicker" position="bottom">
          <van-picker
            :columns="contactCompanyList"
            value-key="name"
            show-toolbar
            @confirm="
              value => {
                form.contactCode = value.id;
                form.contactCompany = value.name;
                changeContact(form.contactCode);
                contactCompanyPicker = false;
              }
            "
            @cancel="contactCompanyPicker = false"
          />
        </van-popup>

        <van-field is-link v-if="approvalType === 3" v-model="form.relationBillTypeName" label="关联单据类型" placeholder="请选择" @click="relationBillTypePicker = true" />
        <van-popup v-model="relationBillTypePicker" position="bottom">
          <van-picker
            :columns="relationBillTypeList"
            value-key="label"
            show-toolbar
            @confirm="
              value => {
                form.relationBillTypeName = value.label;
                form.relationBillType = value.value;
                relationBillTypePicker = false;
              }
            "
            @cancel="relationBillTypePicker = false"
          />
        </van-popup>
        <van-field v-if="approvalType === 3" v-model="form.relationBillNo" rows="1" autosize label="关联单据" type="textarea" placeholder="请输入" />
        <van-field is-link v-if="approvalType === 2 || approvalType === 4" v-model="form.loanBillId" readonly label="借款单" placeholder="请选择" @click="loanBillIdPicker = true" />
        <van-popup v-model="loanBillIdPicker" position="bottom">
          <van-picker
            :columns="loanBillIdList"
            value-key="code"
            show-toolbar
            @confirm="
              value => {
                form.loanBillId = value.code; // 兼容报销单
                form.loanCode = value.code; // 兼容差旅单
                form.originalLoan = value.actualBorrowAmount;
                loanBillIdPicker = false;
              }
            "
            @cancel="loanBillIdPicker = false"
          />
        </van-popup>
        <van-field v-if="approvalType === 2" rows="1" v-model="form.originalLoan" autosize label="原借款(元)" type="number" placeholder="请输入" />

        <van-cell-group>
          <van-field v-if="approvalType === 1" rows="1" v-model="form.reasonsBorrowing" required :rules="[{ required: true }]" autosize label="借款事由" type="textarea" placeholder="请输入" />
          <van-field v-if="approvalType === 2" rows="1" v-model="form.reasons" required :rules="[{ required: true }]" autosize label="报销事由" type="textarea" placeholder="请输入" />
          <van-field v-if="approvalType === 3" rows="1" v-model="form.remark" required :rules="[{ required: true }]" autosize label="付款事由" type="textarea" placeholder="请输入" />
          <van-field v-if="approvalType === 4" rows="1" v-model="form.reasons" required :rules="[{ required: true }]" autosize label="出差事由" type="textarea" placeholder="请输入" />
          <van-field v-if="approvalType === 5" rows="1" v-model="form.reasons" required :rules="[{ required: true }]" autosize label="用途描述" type="textarea" placeholder="请输入" />
        </van-cell-group>

        <van-field is-link v-if="approvalType == 2" readonly class="cb-textarea" v-model="form.relateApprovalNo" label="关联审批单" placeholder="请选择" @click="oaPicker = true" />
        <van-field is-link v-if="approvalType == 4" readonly class="cb-textarea" v-model="form.relateApprovalNo" label="出差审批单" placeholder="请选择" @click="oaPicker = true" />
        <van-cell v-if="approvalType == 4" title="注: 如需选其他公司出差审批单, 请上传该审批单附件" title-style="color:#666" />

        <van-popup v-model="oaPicker" position="bottom" :style="{ height: '35%' }">
          <div>
            <van-checkbox-group v-model="oaGetdata" class="oa-cb" @change="getCbApprovalNo">
              <van-checkbox :name="item.approvalNo" class="cb-li" v-for="item in oaData" :key="item.approvalNo">{{ item.modelName }} - {{ item.approvalNo }}</van-checkbox>
            </van-checkbox-group>
          </div>

          <div v-if="oaData.length == 0" style="text-align: center">暂无数据！</div>
        </van-popup>

        <!--  -->
      </div>

      <!-- 银行卡列表 -->
      <van-popup v-model="payPicker" position="bottom">
        <van-picker
          :columns="payBank"
          value-key="bankAccount"
          show-toolbar
          @confirm="
            value => {
              payChange(value);
              payPicker = false;
            }
          "
          @cancel="payPicker = false"
        />
      </van-popup>

      <div class="peopleDeatail" v-if="approvalType !== 5 && approvalType !== 4">
        <div v-for="(item, index) in payee" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div class="detail_title">收款人信息</div>
            <span class="rtpay" @click="payPicker = true">切换收款账号</span>
          </div>
          <van-cell-group>
            <van-field
              v-if="approvalType == 3"
              :readonly="readonlyPayUnit"
              v-model="item.accountName"
              required
              :rules="[{ required: true }]"
              rows="1"
              autosize
              label="账号名称"
              type="textarea"
              placeholder="请输入"
            />
            <van-field
              v-if="approvalType != 3"
              :readonly="readonlyPayUnit"
              required
              :rules="[{ required: true }]"
              v-model="item.payeeName"
              rows="1"
              autosize
              label="收款人"
              type="textarea"
              placeholder="请输入"
            />
            <van-field v-if="approvalType == 2" v-model="item.collectionAmount" required :rules="[{ required: true }]" rows="1" autosize label="收款金额(元)" type="number" placeholder="请输入" />
            <van-field v-model="item.depositBank" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="开户银行" type="textarea" placeholder="请输入" />
            <van-field v-model="item.bankAccount" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="银行账号" type="textarea" placeholder="请输入" />
            <van-field v-model="item.bankOutlets" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="银行网点" type="textarea" placeholder="请输入" />
            <van-field v-if="approvalType != 3" v-model="item.remark" rows="1" autosize label="备注描述" type="textarea" placeholder="请输入" />
            <van-field v-if="approvalType == 3" v-model="item.swiftCode" rows="1" autosize label="swiftCode" type="textarea" placeholder="请输入" />
          </van-cell-group>
        </div>
      </div>
      <div class="peopleDeatail" v-if="approvalType === 4">
        <div v-for="(item, index) in travelPayee" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div class="detail_title">收款人信息</div>
            <span class="rtpay" @click="payPicker = true">切换收款账号</span>
          </div>
          <van-cell-group>
            <van-field v-model="item.company" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="收款人" type="textarea" placeholder="请输入" />
            <van-field v-model="item.amount" required :rules="[{ required: true }]" rows="1" autosize label="收款金额（元）" type="number" placeholder="请输入" />
            <van-field v-model="item.bank" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="开户银行" type="textarea" placeholder="请输入" />
            <van-field v-model="item.account" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="银行账号" type="textarea" placeholder="请输入" />
            <van-field v-model="item.outlets" :readonly="readonlyPayUnit" required :rules="[{ required: true }]" rows="1" autosize label="银行网点" type="textarea" placeholder="请输入" />
            <van-field v-model="item.remark" rows="1" autosize label="备注描述" type="textarea" placeholder="请输入" />
          </van-cell-group>
        </div>
      </div>
      <div class="peopleDeatail" v-if="approvalType === 1">
        <div v-for="(item, index) in borrowList" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div class="detail_title">借款明细</div>
            <div>
              <img v-if="borrowList.length > 1" @click.stop="handleDeleteBorrow(index)" class="add_item" src="@/assets/delete01.svg" />
              <img @click.stop="handleAdd(1)" class="add_item" src="../assets/join01.png" />
            </div>
          </div>
          <van-field is-link readonly v-model="item.expenseItemName" required :rules="[{ required: true }]" name="picker" label="费用项目" placeholder="请选择" @click="fcsProjectPicker = true" />
          <van-popup v-model="fcsProjectPicker" position="bottom">
            <van-picker
              :columns="fcsProjectList"
              value-key="name"
              show-toolbar
              @confirm="
                value => {
                  item.expenseItemId = value.code;
                  item.expenseItemName = value.name;
                  fcsProjectPicker = false;
                }
              "
              @cancel="fcsProjectPicker = false"
            />
          </van-popup>

          <van-field rows="1" autosize v-model="item.applyAmount" required :rules="[{ required: true }]" label="申请金额" type="number" placeholder="请输入" />
          <van-field rows="1" autosize v-model="item.remark" label="备注描述" type="textarea" placeholder="请输入" />
        </div>
      </div>
      <div class="peopleDeatail" v-if="approvalType === 2">
        <div v-for="(item, index) in expenseList" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div class="detail_title">报销明细</div>
            <div>
              <img v-if="expenseList.length > 1" @click.stop="handleDeleteExpense(index)" class="add_item" src="@/assets/delete01.svg" />
              <img @click.stop="handleAdd(2)" class="add_item" src="../assets/join01.png" />
            </div>
          </div>
          <van-field is-link readonly v-model="item.expenseItemName" required :rules="[{ required: true }]" name="picker" label="费用项目" placeholder="请选择" @click="fcsProjectPicker = true" />
          <van-popup v-model="fcsProjectPicker" position="bottom">
            <van-picker
              :columns="fcsProjectList"
              value-key="name"
              show-toolbar
              @confirm="
                value => {
                  item.expenseItemId = value.code;
                  item.expenseItemName = value.name;
                  fcsProjectPicker = false;
                }
              "
              @cancel="fcsProjectPicker = false"
            />
          </van-popup>
          <van-cell-group>
            <van-field v-model="item.expenseAmount" required :rules="[{ required: true }]" rows="1" autosize label="费用金额(元)" type="number" placeholder="请输入" />
          </van-cell-group>
          <van-field v-model="item.remark" rows="1" autosize label="备注" type="textarea" placeholder="请输入" />
        </div>
      </div>
      <div class="peopleDeatail" v-if="approvalType === 3">
        <div v-for="(item, index) in payList" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div>付款申请</div>
            <div>
              <img v-if="payList.length > 1" @click.stop="handleDeletePay(index)" class="add_item" src="@/assets/delete01.svg" />
              <img @click.stop="handleAdd(3)" class="add_item" src="../assets/join01.png" />
            </div>
          </div>
          <van-field is-link readonly v-model="item.expenseItemName" required :rules="[{ required: true }]" name="picker" label="费用项目" placeholder="请选择" @click="fcsProjectPicker = true" />
          <van-popup v-model="fcsProjectPicker" position="bottom">
            <van-picker
              :columns="fcsProjectList"
              value-key="name"
              show-toolbar
              @confirm="
                value => {
                  item.expenseItemName = value.name;
                  item.expenseItemId = value.code;
                  fcsProjectPicker = false;
                }
              "
              @cancel="fcsProjectPicker = false"
            />
          </van-popup>
          <van-cell-group>
            <van-field v-model="item.claimAmount" required :rules="[{ required: true }]" rows="1" autosize label="费用金额(元)" type="number" placeholder="请输入" />
            <!-- <van-field v-model="item.expenseAmount" required :rules="[{ required: true }]" rows="1" autosize label="申请报销金额(元)" type="number" placeholder="请输入" /> -->
            <!-- <van-field v-model="item.actualAmount" required :rules="[{ required: true }]" rows="1" autosize label="实际付款金额(元)" type="number" placeholder="请输入" /> -->
          </van-cell-group>
          <van-field v-model="item.purpose" rows="1" autosize label="用途描述" type="textarea" placeholder="请输入" />
        </div>
      </div>
      <div class="peopleDeatail" v-if="approvalType === 4">
        <div v-for="(item, index) in travelList" :key="index" style="margin-bottom: 10px">
          <div class="title_header">
            <div class="detail_title">报销明细</div>
            <div>
              <img v-if="travelList.length > 1" @click.stop="handleDeleteTravel(index)" class="add_item" src="@/assets/delete01.svg" />
              <img @click.stop="handleAdd(4)" class="add_item" src="../assets/join01.png" />
            </div>
          </div>
          <van-field is-link readonly v-model="item.expenseItem" required :rules="[{ required: true }]" name="picker" label="费用项目" placeholder="请选择" @click="fcsProjectPicker = true" />
          <van-popup v-model="fcsProjectPicker" position="bottom">
            <van-picker
              :columns="fcsProjectList"
              value-key="name"
              show-toolbar
              @confirm="
                value => {
                  item.expenseItem = value.name;
                  fcsProjectPicker = false;
                }
              "
              @cancel="fcsProjectPicker = false"
            />
          </van-popup>
          <van-field is-link readonly v-model="item.stratDate" required :rules="[{ required: true }]" name="picker" label="开始日期" placeholder="请选择" @click="stratDatePicker = true" />
          <van-popup v-model="stratDatePicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              type="date"
              @confirm="
                value => {
                  item.stratDate = value ? $dayjs(value).format('YYYY-MM-DD') : null;
                  stratDatePicker = false;
                }
              "
              @cancel="stratDatePicker = false"
            />
          </van-popup>
          <van-field is-link readonly v-model="item.endDate" required :rules="[{ required: true }]" name="picker" label="结束日期" placeholder="请选择" @click="endDatePicker = true" />
          <van-popup v-model="endDatePicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              :min-date="minDate"
              :max-date="maxDate"
              type="date"
              @confirm="
                value => {
                  item.endDate = value ? $dayjs(value).format('YYYY-MM-DD') : null;
                  endDatePicker = false;
                }
              "
              @cancel="endDatePicker = false"
            />
          </van-popup>
          <van-cell-group>
            <van-field v-model="item.departure" required :rules="[{ required: true }]" rows="1" autosize label="出发地" type="textarea" placeholder="请输入" />
            <van-field v-model="item.destination" required :rules="[{ required: true }]" rows="1" autosize label="目的地" type="textarea" placeholder="请输入" />
            <van-field v-model="item.days" required :rules="[{ required: true }]" rows="1" autosize label="天数" type="number" placeholder="请输入" />
            <van-field v-model="item.airFare" required :rules="[{ required: true }]" rows="1" autosize label="机票费" type="number" placeholder="请输入" />
            <van-field v-model="item.fare" required :rules="[{ required: true }]" rows="1" autosize label="车船费" type="number" placeholder="请输入" />
            <van-field v-model="item.localFare" required :rules="[{ required: true }]" rows="1" autosize label="市内交通费" type="number" placeholder="请输入" />
            <van-field v-model="item.hotelExpense" required :rules="[{ required: true }]" rows="1" autosize label="住宿费" type="number" placeholder="请输入" />
            <van-field v-model="item.subsidy" required :rules="[{ required: true }]" rows="1" autosize label="出差补助" type="number" placeholder="请输入" />

            <van-field v-model="item.thrift" required :rules="[{ required: true }]" rows="1" autosize label="住宿节约补助" type="number" placeholder="请输入" />
            <van-field v-model="item.other" required :rules="[{ required: true }]" rows="1" autosize label="其他费用" type="number" placeholder="请输入" />
            <van-field is-link readonly v-model="item.invType" required :rules="[{ required: true }]" name="picker" label="发票类型" placeholder="请选择" @click="invoiceTypePicker = true" />
            <van-popup v-model="invoiceTypePicker" position="bottom">
              <van-picker
                :columns="invoiceTypeList"
                value-key="name"
                show-toolbar
                @confirm="
                  value => {
                    item.invType = value.name;
                    item.invCode = value.id;
                    invoiceTypePicker = false;
                  }
                "
                @cancel="invoiceTypePicker = false"
              />
            </van-popup>
            <van-field :value="setAmount(item)" readonly rows="1" autosize label="金额(小计)" type="number" placeholder="请输入" />
            <van-field v-model="item.remark" rows="1" autosize label="备注" type="textarea" placeholder="请输入" />
          </van-cell-group>
        </div>
      </div>
      <div class="peopleDeatail">
        <van-field is-link readonly v-model="sendPickerName" name="picker" label="附件类型" @click="sendPicker = true" />
        <van-popup v-model="sendPicker" position="bottom">
          <van-picker
            :columns="sendType"
            value-key="name"
            show-toolbar
            @confirm="
              (value, index) => {
                sendPickerName = value.name;
                sendPickerInd = value.id;
                sendPicker = false;
                sendInd = index;
              }
            "
            @cancel="sendPicker = false"
          />
        </van-popup>

        <div v-for="items in sendType" :key="items.id">
          <van-field name="uploader" label="附件" label-class="detail_title" placeholder="请上传附件" v-show="items.lineId == sendInd">
            <template #input>
              <van-uploader
                :max-count="99"
                :before-read="beforeRead"
                :after-read="file => afterRead(file)"
                :before-delete="file => beforeDelete(file)"
                accept="*"
                :multiple="true"
                :preview-image="false"
              >
                <template>
                  <div>
                    <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
                  </div>
                </template>
              </van-uploader>
            </template>
          </van-field>

          <div v-for="(i, index) in items.files" :key="index" v-show="items.lineId == sendInd" style="display: flex; justify-content: space-between; align-items: center; padding: 10px 16px">
            <div class="annex-name" @click="preview(i.url)">
              <img style="width: 22px; height: 20px; margin-right: 8px" src="@/assets/file@2x.png" />
              <div style="display: flex; flex-direction: column">
                <div style="width: 5rem; overflow: hidden; white-space: nowrap; text-overflow: ellipsis">{{ i.name }}</div>
                <div v-if="formatSize(i) != 'undefinedB'">{{ formatSize(i) }}</div>
              </div>
            </div>
            <div class="annex-button" @click="deleteFile(index)">删除</div>
          </div>
        </div>
      </div>
      <!-- 合计总额 -->
      <div class="peopleDeatail" v-if="approvalType !== 5">
        <van-field rows="1" v-model="totalAmount" autosize label="合计总额(元)" label-class="detail_title" type="textarea" placeholder="请输入" />
      </div>
      <!-- 金额 -->
      <div class="peopleDeatail" v-if="approvalType === 5">
        <div style="height: 0.8rem; line-height: 0.8rem; font-weight: bold; padding-left: 0.5rem">金额</div>
        <van-field rows="1" v-model="form.drawAmount" required :rules="[{ required: true }]" autosize label="领款金额(元)" label-class="detail_title" type="textarea" placeholder="请输入" />
      </div>

      <!-- 审批流程 -->
      <div class="peopleDeatail">
        <p>流程</p>
        <div class="process-start">
          <div style="display: flex">
            <div style="width: 0.6rem">
              <div class="circular"></div>
              <div class="strip"></div>
            </div>
            <div>
              <div style="color: #333333; font-size: 14px">发起申请</div>
            </div>
          </div>
        </div>

        <div class="process-start" v-for="(link, parentInd) in modelLinks" :key="parentInd">
          <div style="display: flex">
            <div style="width: 0.6rem">
              <div class="circular"></div>
              <div class="strip" :class="parentInd == modelLinks.length - 1 ? 'process-hide' : ''"></div>
            </div>

            <div>
              <div style="color: #333333; font-size: 14px">
                <span v-if="link.userType === 'approver'">
                  <span v-if="modelLinkData.kitValue == 99">接收人</span>
                  <span v-else>审批人</span>
                </span>
                <span v-if="link.userType !== 'approver'">办理人</span>
              </div>
              <div class="select-number">{{ handleSelectNumber(link, parentInd) }}</div>
            </div>

            <div class="approve-list">
              <div v-for="(i, ind) in link.members" :key="i.staffId">
                <div class="selected-member">
                  <img v-if="i.avatar" class="member-img" :src="i.avatar" />
                  <img v-else class="member-img" src="@/assets/default.png" />

                  <div v-if="link.approvalMemberType == 'optional'" class="member-delete" @click="deleteMember(parentInd, ind)">-</div>
                  <div class="member-name">{{ i.staffName }}</div>
                </div>
              </div>
            </div>

            <div class="approve-alreadySelect" v-if="link.approvalMemberType == 'optional'">
              <div class="member-plus" @click="selectApprove(parentInd)">
                <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="peopleDeatail">
        <p>抄送人</p>

        <div class="process-start">
          <div style="display: flex">
            <div>{{ handleSelectCopyNumber() }}</div>

            <div v-for="i in modelCopyLink" :key="i.staffId">
              <div class="selected-member">
                <img v-if="i.avatar" class="member-img" :src="i.avatar" />
                <img v-else class="member-img" src="@/assets/default.png" />
                <div class="member-name">{{ i.staffName }}</div>
              </div>
            </div>

            <div v-for="(i, ind) in selectCopyLinks" :key="i.id">
              <div class="selected-member">
                <img v-if="i.avatar" class="member-img" :src="i.avatar" />
                <img src="@/assets/default.png" class="member-img" v-else />
                <div class="member-delete" @click="deleteCopyMember(ind)">-</div>
                <div class="member-name">{{ i.staffName }}</div>
              </div>
            </div>

            <div style="cursor: pointer" @click="selectCopyApprove">
              <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
              <div style="font-size: 0.27rem; font-family: PingFangSC-Regular, PingFang SC; font-weight: 400; color: #666666">请添加</div>
            </div>
          </div>
        </div>
      </div>
    </van-form>
    <div class="button_box">
      <van-button @click="handleBack" class="button1">取消</van-button>
      <van-button @click="handleConfirm(1)" class="button1">保存到草稿</van-button>
      <van-button @click="handleConfirm(0)" class="button2">提交审批</van-button>
    </div>
    <van-popup class="uploading_popup" v-model="uploadFileFlag" round>
      <van-loading size="24px">文件上传中...</van-loading>
    </van-popup>
  </div>
</template>

<script>
import axios from 'axios';
import billsApi from '@/axios/bills';

import { Toast } from 'vant';
import { v4 as uuidv4 } from 'uuid';
import { formatSize, numberToAmountUppercase } from '../utils';
import { timeFormatDate } from '@/utils';
import { FormTem } from '@/utils/enum.js';
import { getModelDetails, getApproveAndCopy, submitFormData } from '@/axios/services';

export default {
  data() {
    return {
      routerId: '',
      readonly: false,
      projectApprovalList: [],
      loanAttributionPicker: false,
      budgetList: [
        {
          value: 0,
          label: '预算内'
        },
        {
          value: 1,
          label: '预算外'
        }
      ],
      budgetPicker: false,
      expectedReturnDatePicker: false,
      billDatePicker: false,
      expensesAttributionPicker: false,
      billTypePicker: false,
      billTypeList: [
        {
          label: '采购付款申请',
          value: 1
        },
        {
          label: '其他付款申请',
          value: 2
        },
        {
          label: '销售退款申请',
          value: 3
        },
        {
          label: '其他退款申请',
          value: 4
        },
        {
          label: '费用报销申请',
          value: 5
        },
        {
          label: '工资付款申请',
          value: 6
        },
        {
          label: '保证金付款申请',
          value: 7
        }
      ],

      relationBillTypePicker: false,
      relationBillTypeList: [
        {
          label: '采购对账单',
          value: 1
        },
        {
          label: '采购订单',
          value: 2
        },
        {
          label: 'ISC付款申请单',
          value: 99
        },
        {
          label: '其他类型单据',
          value: 3
        }
      ],
      reimbursementTypeList: [
        {
          label: '申请付款',
          value: 1
        },
        {
          label: '申请退款',
          value: 2
        },
        {
          label: '实报实付',
          value: 3
        },
        {
          label: '申请付款+实报实付',
          value: 4
        },
        {
          label: '申请付款+多人收款',
          value: 5
        },
        {
          label: '申请报销',
          value: 6
        }
      ],

      contactTypesPicker: false,
      contactTypesList: [],
      contactCompanyPicker: false, // 单位选择
      contactCompanyList: [],
      fcsProjectPicker: null,
      fcsProjectList: [],
      applyAmount: null,
      invoiceTypePicker: false,
      invoiceTypeList: null,
      currentDate: new Date(),
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(new Date().getFullYear() + 10, 11, 31),
      approvalType: 1,

      borrowList: [
        {
          applyAmount: null,
          expenseBearDepId: null,
          expenseBearDepName: null,
          expenseItemId: null,
          remark: null
        }
      ],
      expenseList: [
        {
          claimAmount: 0,
          expenseItemId: null,
          expenseItemName: null,
          invoiceTypeId: null,
          invoiceTypeName: null,
          expenseAmount: null,
          taxRate: 0,
          taxAmount: 0,
          refundAmount: null,
          expenseBearDepId: null,
          expenseBearDepName: null,
          remark: null
        }
      ],
      payList: [
        {
          expenseItemId: null,
          expenseItemName: null,
          expenseAmount: 0,
          taxRate: 0,
          taxAmount: 0,
          expenseBearDepName: null,
          expenseBearDepId: null,
          purpose: null
        }
      ],
      travelList: [
        {
          expenseItem: null,
          stratDate: null,
          endDate: null,
          departure: null,
          destination: null,
          days: null,
          airFare: null,
          fare: null,
          localFare: null,
          longFare: null,
          hotelExpense: null,
          subsidy: null,
          thrift: null,
          other: null,
          invType: null,
          taxRate: 0,
          taxAmount: 0,
          amount: null,
          remark: null,
          fileUrl: null,
          fileName: null,
          fileList: []
        }
      ],
      payee: [
        {
          accountName: null,
          bankAccount: null,
          bankOutlets: null,
          depositBank: null,
          payeeName: null,
          remark: null,
          swiftCode: null
        }
      ],
      travelPayee: [
        {
          company: null,
          accountName: null,
          amount: null,
          bank: null,
          account: null,
          outlets: null,
          remark: null
        }
      ],
      stratDatePicker: false,
      endDatePicker: false,
      form: {
        applicant: null,
        applicantId: null,
        applicantDept: null,
        applicantDeptId: null,
        loanType: null,
        loanTypeName: null,
        loanOwnershipName: null,
        loanOwnership: null,
        budget: 0,
        budgetName: '预算内',
        // budget: null,
        // budgetName: null,
        expectedReturnDate: null,
        billDate: null,
        contactUnitType: null,
        contactUnitTypeName: null,
        contactCompany: null,
        contactCode: null,
        reasonsBorrowing: null,
        settlementId: null,
        settlementName: null,
        reimbursementType: null,
        reimbursementTypeName: null,
        currencyId: null,
        currencyName: null,
        costAttributionId: null,
        costAttributionName: null,
        reasons: null,
        billType: null,
        billTypeName: null,
        remark: null,
        drawAmount: null,
        currencyCode: null,
        companyName: null,
        companyId: null,
        rootCompanyName: null,
        rootCompanyId: null,
        relationBillTypeName: null,
        relationBillType: null,
        relationBillNo: null,
        loanBillId: null,
        originalLoan: null,
        draftFlag: 0 //判断提交是否是草稿  1是 0否
      },
      title: '',
      fileList: [],
      uploadFileFlag: false,
      loanBillIdList: [],
      loanBillIdPicker: false,
      userInfo: {},
      reqCommonPage: {
        // 数据中心请求参数
        page: 1,
        size: 2000,
        param: {
          status: 0,
          approvalStatus: 1
        }
      },
      readonlyPayUnit: true,
      oaData: [], // 关联审批单data
      oaPicker: false,
      oaGetdata: [],
      sendType: [
        { name: '发票附件', id: 0, files: [], lineId: 0 },
        { name: '审批单附件', id: 3, files: [], lineId: 1 },
        { name: '其他附件', id: 4, files: [], lineId: 2 }
      ],
      sendInd: 0,
      sendPicker: false,
      sendPickerInd: 0,
      sendPickerName: '发票附件',
      selectCopyLinks: [],
      modelId: '',
      modelArr: [],
      modelLinks: [], // 审批流程人
      modelCopyLink: [], // 审批抄送人
      modelLinkData: {},
      modelCopyLinkData: {},
      lists: {},
      StaffInformation: {},
      projshow: true,
      payPicker: false,
      payBank: []
    };
  },
  computed: {
    totalAmount: {
      get() {
        let total;
        if (this.approvalType == 1) {
          let n = this.borrowList?.reduce((prev, next) => {
            const num = next.applyAmount != null && next.applyAmount != '' ? parseFloat(next.applyAmount) : 0;
            return prev + num;
          }, 0);
          total = n.toFixed(2);
        }
        if (this.approvalType == 2) {
          let n = this.expenseList?.reduce((prev, next) => {
            const num = next.expenseAmount != null && next.expenseAmount != '' ? parseFloat(next.expenseAmount) : 0;
            return prev + num;
          }, 0);
          total = n.toFixed(2);
        }
        if (this.approvalType == 3) {
          let n = this.payList?.reduce((prev, next) => {
            const num = next.claimAmount != null && next.claimAmount != '' ? parseFloat(next.claimAmount) : 0;
            return prev + num;
          }, 0);
          total = n.toFixed(2);
        }
        if (this.approvalType == 4) {
          let n = this.travelList?.reduce((prev, next) => {
            const num = next.amount != null && next.amount != '' ? parseFloat(next.amount) : 0;
            return prev + num;
          }, 0);
          total = n.toFixed(2);
        }
        return total;
      },
      set(v) {}
    }
  },
  mounted() {},
  methods: {
    async checkProjId() {
      const res = await billsApi.queryProjectNameStatus();
      this.projshow = res.data.data;
    },
    setAmount(item) {
      let re = 0;
      let airFare = Number(item.airFare) || 0; // 机票
      let fare = Number(item.fare) || 0; // 车船
      let localFare = Number(item.localFare) || 0; // 市内交通
      let hotelExpense = Number(item.hotelExpense) || 0; // 住宿
      let subsidy = Number(item.subsidy) || 0; // 出差补助
      let thrift = Number(item.thrift) || 0; // 住宿节约补助
      let other = Number(item.other) || 0; // 其他费用

      re = airFare + fare + localFare + hotelExpense + subsidy + thrift + other;
      re = Number(re).toFixed(2);

      item.amount = re;

      return re;
    },
    async getStaffDetails() {
      if (this.routerId) {
        let re = await billsApi.getStaffDetails(); // 走草稿箱
        this.payBank = re.data.data?.bankList || [];
        return;
      }
      const res = await billsApi.getStaffDetails();

      let arr = [];
      arr = res.data.data?.bankList || [];

      this.payBank = arr; // 卡列表

      let o = {};
      if (Array.isArray(arr) && arr.length > 0) {
        o = arr.find(item => item.theDefault === true);
      }

      let type = this.approvalType;
      let payee = this.payee[0]; // 借款单·报销单·付款单
      if (type === 1 || type === 2 || type === 3) {
        this.commonLoanPay(payee, o);
      }

      let travel = this.travelPayee[0]; // 差旅单
      if (type === 4) {
        this.commonTravelPay(travel, o);
      }
    },
    commonTravelPay(travel, o) {
      travel.bank = o.openAccountBank;
      travel.account = o.bankAccount;
      travel.outlets = o.bankBranch;
      travel.company = o.name;
    },
    commonLoanPay(payee, o) {
      payee.depositBank = o.openAccountBank;
      payee.bankAccount = o.bankAccount;
      payee.bankOutlets = o.bankBranch;
      payee.accountName = o.name;
      payee.payeeName = o.name;
    },
    // 银行卡change事件
    payChange(v) {
      v.openAccountBank = v.openAccountBank || v.openingBank; // 兼容供应商字段

      let type = this.approvalType;
      if (type == 4) {
        let travel = this.travelPayee[0]; // 差旅单字段又自己一套字段
        this.commonTravelPay(travel, v);
        return false;
      }

      let payee = this.payee[0];
      this.commonLoanPay(payee, v);
    },
    // 封装
    async commonContactCode({ ...rest }) {
      let re = await rest.func(rest.val);
      let arr = re.data.data?.[rest.list] || [];
      let o = arr.find(itm => (itm.defaultOption || itm.theDefault) === true);

      this.payBank = arr; // 付款单
      this.payBank.map(itm => (itm.name = itm.name || itm.accountName)); // 构造name字段兼容picker组件

      if (rest.action) return false; // action存在就不走下面赋值

      let payee = this.payee[0];

      payee.depositBank = o.openingBank || o.openAccountBank;
      payee.bankAccount = o.bankAccount || '';
      payee.bankOutlets = o.bankBranch || '';
      payee.accountName = o.accountName || o.name;
      payee.payeeName = o.accountName || o.name;

      if (o.currency) {
        let cyData = await billsApi.getCdcCurrency(this.reqCommonPage); // 币种匹配
        let records = cyData?.data?.data?.records || [];
        let o2 = records.find(itm => itm.id === o.currency);

        let form = this.form;
        form.currencyName = o2?.name || form.currencyName;
      }
    },
    // 单位change事件
    async changeContact(val, action) {
      console.log(val, this.form.contactUnitType, '打印');

      let unitType = this.form.contactUnitType;
      if (unitType == 0) {
        this.commonContactCode({ func: billsApi.getSupplier, val, list: 'financialAccountList', action }); // 供应商
      }

      if (unitType == 1) {
        this.commonContactCode({ func: billsApi.getCustomer, val, list: 'invoicingList', action }); // 客户
      }

      if (unitType == 2) {
        this.commonContactCode({ func: billsApi.getStaffDetails, val: '', list: 'bankList', action }); // 部门
      }

      if (unitType == 3) {
        this.commonContactCode({ func: billsApi.getStaff, val, list: 'bankList', action }); // 员工
      }

      if (unitType == 4) {
        this.commonContactCode({ func: billsApi.getRelatedCompanyDetails, val, list: 'financeVoList', action }); // 其他单位
      }
    },
    // 拿到oa关联单的ids
    reqApprovalOldListIds() {
      let obj = {};
      obj.searchWord = this.title;
      obj.status = 0;

      let approvalType = this.approvalType;

      billsApi.approvalOldListIds(obj).then(res => {
        if (res.data.code === 200) {
          if (res.data.data.length == 0) {
            return;
          }

          let data = res.data.data[0];
          let oaCollect = JSON.parse(data.oaCollect);

          // 获取费用项目列表
          let projectCollect = JSON.parse(data.projectCollect);
          this.fcsProjectList = projectCollect;

          let arr = [];
          oaCollect.map(item => {
            arr.push(item.modelId);
          });

          if (approvalType == 2 || approvalType == 4) {
            this.reqapprovalOldList(arr);
          }
        }
      });
    },
    // 获取oa关联单据
    reqapprovalOldList(arr) {
      let obj = {};

      let user = JSON.parse(localStorage.getItem('user'));
      obj.companyId = user.companyId;
      obj.oldToken = user.token;
      obj.modelIds = arr;
      obj.searchWord = '';

      let approvalType = this.approvalType;
      if (approvalType == 2) {
        obj.type = 1;
      }
      if (approvalType == 4) {
        obj.type = 2;
      }

      billsApi.approvalOldList(obj).then(res => {
        if (res.data.code === 200) {
          this.oaData = res.data.data;
        }
      });
    },
    // 获取form的approvalNo字段内容
    getCbApprovalNo(val) {
      let v = val.join(',');
      this.$set(this.form, 'relateApprovalNo', v);
    },
    // 关于流程的事件
    getKitId(user) {
      let typeId = null;
      let type = this.$route.query?.type;
      if (type == 1) {
        typeId = 24;
      } // 借款
      if (type == 2) {
        typeId = 25;
      } // 费用报销
      if (type == 3) {
        typeId = 26;
      } // 付款申请
      if (type == 4) {
        typeId = 27;
      } // 差旅
      if (type == 5) {
        typeId = 28;
      } // 领款

      billsApi
        .getApproveModelId({
          companyId: user.companyId,
          oldToken: user.token,
          type: typeId
        })
        .then(res => {
          let result = res.data;
          this.modelId = result.data.modelId; // 模板id

          this.getApproveModel();
          this.getModelLinks(user);
        })
        .catch(ex => {
          Toast.fail(ex.message || '获取流程模板失败');
        });
    },
    // 获取模板字段进行一一对应
    getApproveModel() {
      let id = this.modelId;
      getModelDetails(id).then(res => {
        let result = res.data;

        let arr = [];
        let fields = result.data.formData.fields;
        fields.map(i => {
          if (i.children && i.children.length != 0) {
            arr.push(i.children);
          }
        });
        this.modelArr = arr.flat(); // 模板对应数组，做参考
      });
    },
    // 获取初始值模板审批人和抄送人
    getModelLinks(user) {
      let obj = {};
      obj.companyId = user.companyId;
      obj.modelId = this.modelId;

      getApproveAndCopy(obj).then(res => {
        if (res.data.code === 0) {
          let result = res.data;

          this.modelLinkData = result.data;
          this.modelLinks = result.data.links;
          this.modelCopyLinkData = result.data.copyLink;
          this.modelCopyLink = result.data.copyLink.members;
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleSelectNumber(item, index) {
      // 处理是几人依次审批
      if (item.approvalMemberType != 'optional') {
        // optional是指手动输入，不等于optional就是后台配死
        let text = '';
        if (item.members) {
          let l = item.members.length;
          text = l + '人依次审批';
        }
        return text;
      }

      let selectedList = this.$store.state.selectedList;
      if (selectedList[`oplink${index}`]) {
        item.members = selectedList[`oplink${index}`];
      }

      let l = 0;
      if (item.members) {
        l = item.members.length;
      }
      let text = l + '人依次审批';

      return text;
    },
    // 选人
    selectApprove(index) {
      let user = JSON.parse(localStorage.getItem('user'));
      let companyId = user.companyId;
      this.$store.state.initialData.companyId = companyId;
      this.$store.commit('setStatus', `oplink${index}`);

      this.bindTypeInfo(); // 回显数据

      sessionStorage.setItem('billLinksType', this.approvalType);
      sessionStorage.setItem('draftFlagId', this.routerId); // 兼容草稿
      this.$router.push('/new-personnel-selection');
    },
    // 各单据数据回显绑定
    bindTypeInfo() {
      let type = this.approvalType;
      sessionStorage.setItem('selectFlag', true); //选择审批人标识

      // 为了数据回显
      if (type == 1) {
        let params = {};
        params.form = this.form;
        params.borrowList = this.borrowList; // 明细
        params.payee = this.payee;
        params.sendType = this.sendType; // 附件
        params.sendPickerName = this.sendPickerName;
        params.sendInd = this.sendInd;
        this.$store.commit('setInfoData', params);
        return;
      }
      if (type == 2) {
        let params = {};
        params.form = this.form;
        params.budgetExecutionType = this.form.budget;
        params.applicationDepartmentName = this.form.applicantDept;
        params.applicantName = this.form.applicant;
        params.applicationDepartmentId = this.form.applicantDeptId;
        params.detailsReqDtos = this.expenseList; // 明细
        params.payeeReqDtos = this.payee;
        params.payeeReqDtos.map(item => {
          item.accountName = item.payeeName;
        });
        params.sendType = this.sendType; // 附件
        params.sendPickerName = this.sendPickerName;
        params.sendInd = this.sendInd;
        this.$store.commit('setInfoData', params);
        return;
      }
      if (type == 3) {
        let params = {};
        params.form = this.form;
        params.budgetExecutionType = this.form.budget;
        params.applicationDepartmentName = this.form.applicantDept;
        params.applicantName = this.form.applicant;
        params.applicationDepartmentId = this.form.applicantDeptId;
        params.contactType = this.form.contactUnitType;
        params.businessType = 10;
        params.detailsReqDtos = this.payList; // 明细
        params.payeeReqDtos = this.payee;
        params.sendType = this.sendType; // 附件
        params.sendPickerName = this.sendPickerName;
        params.sendInd = this.sendInd;
        this.$store.commit('setInfoData', params);
        return;
      }
      if (type == 4) {
        let params = {};
        params.form = this.form;
        params.enterpriseName = this.form.companyName;
        params.enterpriseId = this.form.companyId;
        params.attributionId = this.form.costAttributionId;
        params.attributionName = this.form.costAttributionName;
        params.applicantUid = this.form.applicantId;
        params.applicantUname = this.form.applicant;
        params.departmentId = this.form.applicantDeptId;
        params.departmentName = this.form.applicantDept;
        params.groupOrgId = this.form.rootCompanyId;
        params.groupOrgName = this.form.rootCompanyName;
        params.type = this.form.reimbursementType;
        params.dates = this.form.billDate;
        params.contactType = this.form.contactUnitType;
        params.contactCode = this.form.contactCompany;
        params.items = this.travelList; // 明细
        params.payees = this.travelPayee;
        params.payees.map(item => {
          item.accountName = item.company;
        });
        params.sendType = this.sendType; // 附件
        params.sendPickerName = this.sendPickerName;
        params.sendInd = this.sendInd;
        this.$store.commit('setInfoData', params);
        return;
      }
      if (type == 5) {
        let params = {};
        params.form = this.form;
        params.enterpriseName = this.form.companyName;
        params.enterpriseId = this.form.companyId;
        params.attributionId = this.form.costAttributionId;
        params.attributionName = this.form.costAttributionName;
        params.dates = this.form.billDate;
        params.applicantUid = this.form.applicantId;
        params.applicantUname = this.form.applicant;
        params.departmentId = this.form.applicantDeptId;
        params.departmentName = this.form.applicantDept;
        params.groupOrgId = this.form.rootCompanyId;
        params.groupOrgName = this.form.rootCompanyName;
        params.sendType = this.sendType; // 附件
        params.sendPickerName = this.sendPickerName;
        params.sendInd = this.sendInd;
        this.$store.commit('setInfoData', params);
        return;
      }
    },
    // 删人
    deleteMember(parentInd, ind) {
      this.modelLinks[parentInd].members.splice(ind, 1);
      this.$forceUpdate();
    },
    // 抄送人事件,相当于watch监听
    handleSelectCopyNumber(item, index) {
      let selectedList = this.$store.state.selectedList;
      if (selectedList.billsCopyLinksdata) {
        this.selectCopyLinks = selectedList.billsCopyLinksdata;
      }
      return '';
    },
    selectCopyApprove() {
      let user = JSON.parse(localStorage.getItem('user'));
      let companyId = user.companyId;
      this.$store.state.initialData.companyId = companyId;
      this.$store.commit('setStatus', 'billsCopyLinksdata');

      this.bindTypeInfo(); // 回显数据

      sessionStorage.setItem('billLinksType', this.approvalType);
      sessionStorage.setItem('draftFlagId', this.routerId); // 兼容草稿
      this.$router.push('/new-personnel-selection');
    },
    deleteCopyMember(ind) {
      this.selectCopyLinks.splice(ind, 1);
    },
    // ---
    onClickLeft() {
      if (this.routerId) {
        // 兼容草稿
        this.$router.back();
        return;
      }
      window.location.href = 'jsToOc://back';
    },

    async relevanceLoan() {
      const params = {
        applicantId: this.form.applicantId,
        companyId: this.form.companyId,
        loanOwnership: this.form.costAttributionId
      };

      this.form.loanBillId = '';
      this.form.loanCode = '';

      this.loanBillIdList = (await billsApi.relevanceLoan(params)).data.data || [];
    },
    // 借款归宿、费用归属
    async queryProjectApprovalList() {
      // const user = JSON.parse(localStorage.getItem('user'));
      let id = this.userInfo.user?.userId || '';
      let qcp = {
        // companyId: user.companyId || '',
        // projectName: '',
        // projectApprovalStatus: 3
        userId: id
      };

      const res = await billsApi.queryCompanyProjectList(qcp);

      this.projectApprovalList = res.data?.data || [];
    },

    // 点击往来单位类型事件
    openCompanyPick() {
      if (this.readonlyPayUnit == false) {
        return;
      }
      this.contactCompanyPicker = true;
    },
    // 往来单位类型
    async contactType(v) {
      let type = this.approvalType;
      if (type != 3) return; // 付款单

      const res = await billsApi.contactTypes();
      this.contactTypesList = res.data?.data || [];

      const id = this.$route.query?.id;
      if (id) return false; // 走草稿箱的话不走下面的语句

      let o = JSON.parse(JSON.stringify(this.$store.state.infoData));
      if (o && o.detailsReqDtos) return false; // 走缓存state

      let obj = this.reqCommonPage;
      let result = await billsApi.getStaffList(obj);
      this.contactCompanyList = result.data?.data.records || [];

      console.log(this.userInfo, '999');
      // 带出操作人及银行信息(id：由草稿进的时候可能有id不能执行！)
      if (v == 'add' && !id) {
        const nickName = this.userInfo.user?.nickName;
        let param = {};
        result.data?.data.records.map(itm => {
          if (itm.name == nickName) {
            param = itm;
          }
        });
        this.form.contactCompany = param.name;
        this.form.contactCode = param.id;
        this.changeContact(param.id);
      }
    },

    async handleChange(contactType) {
      // change 往来单位类型置空
      let payee = this.payee[0];
      Object.keys(payee).forEach(key => {
        this.$set(payee, key, null);
      });

      this.form.contactCompany = null;
      this.form.contactCode = null;

      this.readonlyPayUnit = true;
      let obj = this.reqCommonPage;
      if (contactType == '供应商') {
        let res = await billsApi.getSupplierList(obj);
        this.contactCompanyList = res.data?.data.records || [];
      }

      if (contactType == '客户') {
        let res = await billsApi.getCustomerList(obj);
        this.contactCompanyList = res.data?.data.records || [];
      }

      if (contactType == '部门') {
        let res = await billsApi.getDeptfList(obj);
        this.contactCompanyList = res.data?.data.records || [];
      }

      if (contactType == '员工') {
        let res = await billsApi.getStaffList(obj);
        this.contactCompanyList = res.data?.data.records || [];
      }

      if (contactType == '其他往来单位') {
        let res = await billsApi.getRelatedCompany(obj);
        this.contactCompanyList = res.data?.data.records || [];
      }
    },

    flatten(arr) {
      // 数组扁平化
      let res = [];
      arr.map(item => {
        if (Array.isArray(item)) {
          res = res.concat(this.flatten(item));
        } else {
          res.push(item);
        }
      });
      return res;
    },

    // 发票类型
    async getDropList() {
      let type = this.approvalType;
      if (type != 4) return; // 4 差旅单才有发票类型

      const res = await billsApi.getDropList();
      this.invoiceTypeList = res.data?.data || [];
    },
    handleBack() {
      window.location.href = 'jsToOc://back';
    },
    async bindTwiceParam(data) {
      let obj = {};
      let user = JSON.parse(localStorage.getItem('user'));
      obj.companyId = user.companyId;
      obj.draftFlag = '1';
      obj.instanceId = '';
      obj.links = this.modelLinks;
      obj.copyLink = {};
      obj.copyLink = this.modelCopyLinkData;
      obj.copyLink.members = this.modelCopyLink;
      obj.modelId = this.modelId;

      // 附件额外处理
      let farr = [];
      if (data.files) {
        let files = data.files;
        let fparam = [];
        files.map(item => {
          let fobj = {};
          fobj.name = item.fileName;
          fobj.url = item.fileUrl;
          fparam.push(fobj);
        });

        let re = await billsApi.getApproveurls(fparam);
        farr = re.data.data;
      }

      let type = this.approvalType;
      let arr = [];
      let param = {};
      if (type == 1) {
        arr = FormTem.loanApprovalTem;
      }
      if (type == 2) {
        arr = FormTem.exprensiveClaimTem;
      }
      if (type == 3) {
        arr = FormTem.paymentClaimTem;
      }
      if (type == 4) {
        arr = FormTem.travelClaimTem;
      }
      if (type == 5) {
        arr = FormTem.receiveClaimTem;
      }

      type == 1 &&
        arr.map(i1 => {
          // 借款单
          param[i1.vModel] = data.loan[i1.field];

          if (i1.field == 'loanType') {
            param[i1.vModel] = data['loan'][i1.field] === 0 ? '申请借款' : '其他';
          }
          if (i1.field == 'budget') {
            param[i1.vModel] = data['loan'][i1.field] === 0 ? '预算内' : '预算外';
          }
          if (i1.field == 'loanPayee') {
            let arr = [];
            arr.push(data.payee);
            param[i1.vModel] = JSON.stringify(arr);
          }
          if (i1.field == 'loanDetails') {
            param[i1.vModel] = JSON.stringify(data.details);
          }
          if (i1.field == 'fileList') {
            param[i1.vModel] = JSON.stringify(farr);
          }
          if (i1.field == 'expenseAmountTotal') {
            param[i1.vModel] = this.totalAmount;
          }
        });

      type == 2 &&
        arr.map(i1 => {
          // 报销单
          param[i1.vModel] = data[i1.field];

          if (i1.field == 'reimbursementType') {
            let text = '';
            let reimbursementTypeList = this.reimbursementTypeList;

            text = reimbursementTypeList[5].label; // 默认
            reimbursementTypeList.map(item => {
              if (item.value == data[i1.field]) {
                text = item.label;
              }
            });

            param[i1.vModel] = text;
          }
          if (i1.field == 'budgetExecutionType') {
            param[i1.vModel] = data[i1.field] === 0 ? '预算内' : '预算外';
          }

          if (i1.field == 'costPayee') {
            param[i1.vModel] = JSON.stringify(data.payeeVos);
          }
          if (i1.field == 'costDetails') {
            param[i1.vModel] = JSON.stringify(data.detailsVos);
          }
          if (i1.field == 'fileList') {
            param[i1.vModel] = JSON.stringify(farr);
          }
          if (i1.field == 'expenseAmountTotal') {
            let total = this.totalAmount;
            let upper = ` ${numberToAmountUppercase(total)} `; // 加入金额大写
            total += upper;
            param[i1.vModel] = total;
          }
        });

      type == 3 &&
        arr.map(i1 => {
          // 付款单
          param[i1.vModel] = data[i1.field];

          if (i1.field == 'billType') {
            let text = '';
            let billTypeList = this.billTypeList;
            billTypeList.map(item => {
              if (item.value == data[i1.field]) {
                text = item.label;
              }
            });

            param[i1.vModel] = text;
          }
          if (i1.field == 'budgetExecutionType') {
            param[i1.vModel] = data[i1.field] === 0 ? '预算内' : '预算外';
          }
          if (i1.field == 'contactType') {
            let text = '';
            let contactTypesList = this.contactTypesList;
            contactTypesList.map(item => {
              if (item.key == data[i1.field]) {
                text = item.value;
              }
            });

            param[i1.vModel] = text;
          }
          if (i1.field == 'relationBillType') {
            let text = '';
            let relationBillTypeList = this.relationBillTypeList;
            relationBillTypeList.map(item => {
              if (item.value == data[i1.field]) {
                text = item.label;
              }
            });

            param[i1.vModel] = text;
          }
          if (i1.field == 'payee') {
            param[i1.vModel] = JSON.stringify(data.payeeVos);
          }
          if (i1.field == 'detail') {
            param[i1.vModel] = JSON.stringify(data.detailsVos);
          }
          if (i1.field == 'fileList') {
            param[i1.vModel] = JSON.stringify(farr);
          }
          if (i1.field == 'expenseAmountTotal') {
            let total = this.totalAmount;
            let upper = ` ${numberToAmountUppercase(total)} `; // 加入金额大写
            total += upper;
            param[i1.vModel] = total;
          }
        });

      type == 4 &&
        arr.map(i1 => {
          // 差旅单
          param[i1.vModel] = data[i1.field];

          if (i1.field == 'payee') {
            param[i1.vModel] = JSON.stringify(data.payees);
          }
          if (i1.field == 'detail') {
            param[i1.vModel] = JSON.stringify(data.items);
          }
          if (i1.field == 'fileList') {
            param[i1.vModel] = JSON.stringify(farr);
          }
          if (i1.field == 'expenseAmountTotal') {
            param[i1.vModel] = this.totalAmount;
          }
        });

      type == 5 &&
        arr.map(i1 => {
          // 领款单
          param[i1.vModel] = data[i1.field];

          if (i1.field == 'fileList') {
            param[i1.vModel] = JSON.stringify(farr);
          }
        });

      let re = JSON.stringify(param); // 两次
      obj.fieldsStr = re;

      return obj;
    },
    // 绕过待审批到已审批
    commonTwiceAdd(param, type, methods) {
      let extId = param;
      billsApi[methods](extId).then(res => {
        let data = res.data.data;

        if (type == 25 || type == 27) {
          let balance = data.refundableBalance; // 构造报销单应付/应退
          data.balance = balance;
          if (balance < 0) data.balance = balance.slice(1);
        }

        if (type == 25) {
          let n = data.balance;
          let upper = ` ${numberToAmountUppercase(n)} `; // 费用报销单金额大写
          n += upper;
          data.balance = n;

          let n2 = data.originalLoan;
          let upper2 = ` ${numberToAmountUppercase(n2)} `;
          n2 += upper2;
          data.originalLoan = n2;
        }

        this.bindTwiceParam(data).then(async twiceParam => {
          //二次构造数据，为绕过待审核服务
          // 加入token
          let config = {};
          let user = JSON.parse(localStorage.getItem('user'));
          config = {
            headers: {
              Token: user?.newToken
            }
          };
          twiceParam.platformModuleId = extId;

          submitFormData(twiceParam, config).then(res => {
            if (res.data.code === 0) {
              this.routerId = '';
              Toast('提交审批成功!');
              setTimeout(() => {
                this.onClickLeft();
              }, 500);
            } else {
              Toast.fail(res.data.msg);
            }
          });
        });
      });
    },
    onSubmit() {
      // 批量附件处理
      let arr = [];
      let sendType = this.sendType;
      for (let i = 0; i < 3; i++) {
        arr.push(sendType[i].files);
      }
      arr = arr.flat();
      this.form.files = arr;

      if (this.approvalType === 1) {
        const params = {
          id: this.routerId,
          loan: {
            ...this.form,
            company: this.form.companyName,
            groupId: this.form.rootCompanyId,
            groupName: this.form.rootCompanyName
          },
          files: arr,
          // details: this.borrowList,
          details: this.borrowList.map(item => ({
            ...item,
            id: null
          })),
          payee: this.payee.map(item => ({
            ...item,
            accountName: item.payeeName,
            id: null
          }))[0]
        };

        //没有id走添加
        if (this.routerId == '') {
          billsApi.addLoan(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(res.data.data, 24, 'getLoanInfo');
                // this.newApplyFormLink(res.data.data, 24);
              } else {
                this.draftsLink(0);
              }
            }
          });
        } else {
          billsApi.editLoan(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(this.routerId, 24, 'getLoanInfo');
                // this.newApplyFormLink(this.routerId, 24);
              } else {
                this.draftsLink(0);
              }
            }
          });
        }
      }
      if (this.approvalType === 2) {
        //费用报销单
        const params = {
          id: this.routerId,
          ...this.form,
          budgetExecutionType: this.form.budget,
          applicationDepartmentId: this.form.applicantDeptId,
          applicantName: this.form.applicant,
          applicationDepartmentName: this.form.applicantDept,
          payeeReqDtos: this.payee.map(item => ({
            ...item,
            accountName: item.payeeName,
            id: null
          })),
          // detailsReqDtos: this.expenseList,
          detailsReqDtos: this.expenseList.map(item => ({
            ...item,
            id: null
          }))
        };

        //没有id走添加
        if (this.routerId == '') {
          billsApi.addCost(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(res.data.data, 25, 'getCostInfo');
                // this.newApplyFormLink(res.data.data, 25);
              } else {
                this.draftsLink(1);
              }
            }
          });
        } else {
          billsApi.editCost(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(this.routerId, 25, 'getCostInfo');
                // this.newApplyFormLink(this.routerId, 25);
              } else {
                this.draftsLink(1);
              }
            }
          });
        }
      }
      if (this.approvalType === 3) {
        //付款申请单
        const params = {
          id: this.routerId,
          ...this.form,
          budgetExecutionType: this.form.budget,
          // payeeReqDtos: this.payee,
          payeeReqDtos: this.payee.map(item => ({
            ...item,
            id: null
          })),
          // applicationDepartmentName: '部门名称',
          applicationDepartmentName: this.form.applicantDept,
          // detailsReqDtos: this.payList,
          detailsReqDtos: this.payList.map(item => ({
            ...item,
            id: null
          })),
          applicantName: this.form.applicant,
          businessType: 10, // 无效值
          // applicationDepartmentId: '12315432',
          applicationDepartmentId: this.form.applicantDeptId,
          contactType: this.form.contactUnitType
        };
        //没有id走添加
        if (this.routerId == '') {
          billsApi.addPaymentApplication(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(res.data.data, 26, 'applicationInfo');
                // this.newApplyFormLink(res.data.data, 26);
              } else {
                this.draftsLink(2);
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          billsApi.editPaymentApplication(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(this.routerId, 26, 'applicationInfo');
                // this.newApplyFormLink(this.routerId, 26);
              } else {
                this.draftsLink(2);
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      }
      if (this.approvalType === 4) {
        //差旅报销单
        const params = {
          id: this.routerId,
          ...this.form,
          enterpriseName: this.form.companyName,
          enterpriseId: this.form.companyId,
          attributionId: this.form.costAttributionId,
          attributionName: this.form.costAttributionName,
          applicantUid: this.form.applicantId,
          applicantUname: this.form.applicant,
          departmentId: this.form.applicantDeptId,
          departmentName: this.form.applicantDept,
          groupOrgId: this.form.rootCompanyId,
          groupOrgName: this.form.rootCompanyName,
          type: this.form.reimbursementType,
          dates: this.form.billDate,
          contactType: this.form.contactUnitType,
          contactCode: this.form.contactCompany,
          items: this.travelList,
          payees: this.travelPayee.map(item => ({
            ...item,
            accountName: item.company
          }))
        };

        //没有id走添加
        if (this.routerId == '') {
          params.advanceAmount = params.originalLoan; // 对应pc的预支
          billsApi.addtravelExpenses(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(res.data.data, 27, 'travelExpensesReimbursementDetail');
                // this.newApplyFormLink(res.data.data, 27);
              } else {
                this.draftsLink(3);
              }
            }
          });
        } else {
          billsApi.editTravelExpenses(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(this.routerId, 27, 'travelExpensesReimbursementDetail');
                // this.newApplyFormLink(this.routerId, 27);
              } else {
                this.draftsLink(3);
              }
            } else {
              Toast.fail(res.data.msg);
            }
          });
        }
      }
      if (this.approvalType === 5) {
        // 领款单
        const params = {
          id: this.routerId,
          ...this.form,
          enterpriseName: this.form.companyName,
          enterpriseId: this.form.companyId,
          attributionId: this.form.costAttributionId,
          attributionName: this.form.costAttributionName,
          applicantUid: this.form.applicantId,
          applicantUname: this.form.applicant,
          departmentId: this.form.applicantDeptId,
          departmentName: this.form.applicantDept,
          groupOrgId: this.form.rootCompanyId,
          groupOrgName: this.form.rootCompanyName,
          dates: this.form.billDate
        };
        //没有id走添加
        if (this.routerId == '') {
          billsApi.addReceive(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(res.data.data, 28, 'receiveDetail');
                // this.newApplyFormLink(res.data.data, 28);
              } else {
                this.draftsLink(4);
              }
            }
          });
        } else {
          billsApi.editReceive(params).then(res => {
            if (res.data.code === 200) {
              if (this.form.draftFlag === 0) {
                this.commonTwiceAdd(this.routerId, 28, 'receiveDetail');
                // this.newApplyFormLink(this.routerId, 28);
              } else {
                this.draftsLink(4);
              }
            }
          });
        }
      }
    },
    //跳转到审批
    newApplyFormLink(getId, type) {
      this.$router.push({
        name: 'newApplyForm',
        query: {
          id: getId,
          type: type
        }
      });
    },
    //跳转到草稿
    draftsLink(type) {
      // 兼容草稿，清除旧审批数据
      let lens = this.modelLinks.length;
      for (let i = 0; i < lens; i++) {
        delete this.$store.state.selectedList[`oplink${i}`];
      }
      delete this.$store.state.selectedList.billsCopyLinksdata;

      this.$router.push({
        path: '/draft',
        query: {
          type: type
        }
      });
    },
    handleConfirm(draftFlag) {
      let flag = false;
      if (draftFlag == 0) {
        // 校验审批人是否存在
        let lnks = this.modelLinks;
        lnks.map(i => {
          if (i.approvalMemberType == 'optional' && (!i.members || i.members.length == 0)) {
            flag = true;
          }
        });
      }
      if (flag) {
        // Toast.fail('请选择审批人!');
        // return;
      }

      this.form.draftFlag = draftFlag;
      this.$refs.form.submit();
    },
    handleAdd(flag) {
      if (flag === 1) {
        this.borrowList.push({
          applyAmount: null,
          expenseBearDepId: null,
          expenseBearDepName: null,
          expenseItemId: null,
          remark: null
        });
      }
      if (flag === 2) {
        this.expenseList.push({
          expenseItemId: null,
          expenseItemName: null,
          invoiceTypeId: null,
          invoiceTypeName: null,
          expenseAmount: null,
          taxRate: 0,
          taxAmount: 0,
          claimAmount: 0,
          refundAmount: null,
          expenseBearDepId: null,
          expenseBearDepName: null,
          remark: null
        });
      }
      if (flag === 3) {
        this.payList.push({
          expenseItemId: null,
          expenseItemName: null,
          expenseAmount: null,
          taxRate: 0,
          taxAmount: null,
          expenseBearDepName: null,
          expenseBearDepId: null,
          purpose: null
        });
      }
      if (flag === 4) {
        this.travelList.push({
          expenseItem: null,
          stratDate: null,
          endDate: null,
          departure: null,
          destination: null,
          days: null,
          airFare: null,
          fare: null,
          localFare: null,
          longFare: null,
          hotelExpense: null,
          subsidy: null,
          thrift: null,
          other: null,
          invType: null,
          taxRate: 0,
          taxAmount: 0,
          amount: null,
          remark: null,
          fileUrl: null,
          fileName: null,
          fileList: []
        });
      }
      if (flag === 'payee') {
        this.payee.push({
          accountName: null,
          bankAccount: null,
          bankOutlets: null,
          depositBank: null,
          payeeName: null,
          remark: null
        });
      }
      if (flag === 'travelPayee') {
        this.travelPayee.push({
          company: null,
          accountName: null,
          amount: null,
          bank: null,
          account: null,
          outlets: null,
          remark: null
        });
      }
    },
    handleDeleteBorrow(index) {
      this.borrowList.splice(index, 1);
    },
    handleDeleteExpense(index) {
      this.expenseList.splice(index, 1);
    },
    handleDeletePayee(index) {
      this.payee.splice(index, 1);
    },
    handleDeletePay(index) {
      this.payList.splice(index, 1);
    },
    handleDeleteTravel(index) {
      this.travelList.splice(index, 1);
    },
    handleDeleteTravelPayee(index) {
      this.travelPayee.splice(index, 1);
    },

    getRelevanceLoan() {
      if (this.form.companyId && this.form.applicantId && this.form.costAttributionId) {
        this.relevanceLoan();
      }
    },

    beforeRead(file) {
      this.uploadFileFlag = true;
      let hasArray = Array.isArray(file);

      let arr = []; // 构造数组 file可能是1或者多
      if (!hasArray) {
        arr.push(file);
      } else {
        arr = file;
      }

      let res = true;
      arr.some(i => {
        if (
          i.name.indexOf('.doc') != -1 ||
          i.name.indexOf('.docx') != -1 ||
          i.name.indexOf('.ppt') != -1 ||
          i.name.indexOf('.pptx') != -1 ||
          i.name.indexOf('.txt') != -1 ||
          i.name.indexOf('.jpg') != -1 ||
          i.name.indexOf('.jpeg') != -1 ||
          i.name.indexOf('.png') != -1 ||
          i.name.indexOf('.xlsx') != -1 ||
          i.name.indexOf('.xls') != -1 ||
          i.name.indexOf('.pdf') != -1 ||
          i.name.indexOf('.zip') != -1 ||
          i.name.indexOf('.rar') != -1
        ) {
          if (i.size > 100 * 1024 * 1024) {
            this.uploadFileFlag = false;
            Toast.fail('上传附件大小不能超过100M。');
            res = false;
            return true;
          } else {
            // return Promise.resolve();
          }
        } else {
          this.uploadFileFlag = false;
          Toast.fail('支持文件格式( .doc/.docx/.ppt/.pptx/.txt/.jpg/.jpeg/.png/.xlsx/.xls/.pdf/.zip/.rar)');
          res = false;
          return true;
        }
      });

      if (!res) {
        return false;
      }

      return Promise.resolve();
    },

    async afterRead(file) {
      let hasArray = Array.isArray(file);
      let arr = [];
      if (!hasArray) {
        arr.push(file);
      } else {
        arr = file;
      }

      let obj = {};
      let fileNameList = [];
      let dir = this.$dayjs().valueOf();
      arr.map(i => {
        let name = i.file.name;
        let filePath = `park/${dir}/${name}`;
        fileNameList.push(filePath);
      });
      obj.fileNameList = fileNameList;

      const signData = await billsApi.getSign(obj).catch(() => {
        this.$message.error('获取签名失败');
      });

      let url = signData.data.data;
      await this.pushUrl(url, arr);

      let ind = this.sendPickerInd; // 0发票 3审批单 4其他
      let typeInd = this.sendInd; // 对应行

      url.map((i, index) => {
        this.sendType[typeInd].files.push({
          type: ind,
          name: arr[index].file.name,
          size: arr[index].file.size,
          url: i.substr(0, i.indexOf('?')),
          createTime: new Date()
        });
      });
    },
    // 处理1或者多个附件上传
    async pushUrl(url, file) {
      url.map((i, index) => {
        let type = file[index].file?.type ? file[index].file?.type : 'multipart/form-data';

        axios
          .put(i, file[index].file, {
            headers: { 'Content-Type': type }
          })
          .then(res => {
            this.uploadFileFlag = false;
            Toast('上传成功');
          })
          .catch('文件上传失败');
      });
    },
    beforeDelete(file) {},
    preview(param) {
      if (param.indexOf('.rar') != -1 || param.indexOf('.zip') != -1) {
        return Toast.fail('该文件不支持预览');
      }
      window.location.href = 'jsToOc://fujianJump?url=' + param;
    },
    formatSize(item) {
      return formatSize(item.size, 2);
    },
    deleteFile(index) {
      let typeInd = this.sendInd; // 对应行
      this.sendType[typeInd].files.splice(index, 1);
    },
    async getUserInfo() {
      const res = await billsApi.getUserInfo();
      this.userInfo = res.data?.data || {};
      this.form.applicant = this.userInfo.user?.nickName;
      this.form.applicantId = this.userInfo.user?.userId;
      this.form.applicantDept = this.userInfo.dept?.name;
      this.form.applicantDeptId = this.userInfo.dept?.id;
      this.form.companyName = this.userInfo.tenant?.name;
      this.form.companyId = this.userInfo.tenant?.tenantId;
      this.form.rootCompanyId = this.userInfo.parentTenant?.tenantId || '';
      this.form.rootCompanyName = this.userInfo.parentTenant?.name || '';
      this.form.loanTypeName = '申请借款';
      this.form.loanType = 0;
      this.form.contactUnitType = 3;
      this.form.contactUnitTypeName = '员工';
      this.form.currencyName = '人民币';
      this.form.currencyId = '1636533843624669186';
      this.form.currencyCode = 'rmb';
      this.form.settlementName = '转账';
      this.form.settlementId = '';
      this.form.billDate = this.$dayjs(this.currentDate).format('YYYY-MM-DD');
      this.form.contactCompany = this.userInfo.user?.nickName;
      if (this.approvalType == 3) {
        // 付款申请
        this.form.contactCompany = '';
      }
      this.form.reimbursementType = 7;
      this.form.reimbursementTypeName = '申请报销';
      this.form.billTypeName = '采购付款申请';
      this.form.billType = 1;
    },
    // 检查文件名是否相同
    checkSameFileName(fileList, file) {
      let flag = false;
      fileList.forEach(item => {
        if (file.fileName == item.fileName) {
          flag = true;
          return;
        }
      });
      return flag;
    },
    //附件处理
    filesHandle(fileList) {
      if (fileList != undefined) {
        fileList?.map(item => {
          this.sendType.map(row => {
            if (item.type == row.id) {
              // 把type 传回去
              let obj = {
                ...item,
                name: item.fileName,
                url: item.fileUrl,
                uid: item.id
              };

              row.files.push(obj);
            }
          });
        });
      }
    },
    // 草稿进来-展示详情
    async getDetail(getId) {
      sessionStorage.removeItem('draftFlagId');
      this.form.id = this.routerId;
      const selectFlag = sessionStorage.selectFlag;
      if (selectFlag == 'true') {
        sessionStorage.selectFlag = false;
        return;
      }
      //借款申请单
      if (this.$route.query?.type == 1) {
        const res = await billsApi.getLoanInfo(getId);
        this.payee = [res.data.data?.payee]; //收款人
        this.borrowList = res.data.data?.details; //借款明细
        let fileList = res.data.data?.files; //附件
        this.filesHandle(fileList);

        this.form.loanOwnershipName = res.data.data?.loan.loanOwnershipName; //借款项目归属
        this.form.projectNo = res.data.data?.loan.projectNo;
        this.form.billDate = timeFormatDate(res.data.data?.loan.billDate);
        this.form.budget = res.data.data?.loan.budget; //预算执行
        //预算执行
        this.budgetList.map(item => {
          if (item.value == res.data.data?.loan.budget) {
            this.form.budgetName = item.label;
          }
        });
        this.form.expectedReturnDate = res.data.data?.loan.expectedReturnDate; //预计归还日期
        this.form.reasonsBorrowing = res.data.data?.loan.reasonsBorrowing; //借款事由
      }
      if (this.$route.query?.type == 2) {
        const res = await billsApi.getCostInfo(getId);
        this.payee = res.data.data?.payeeVos; //收款人
        let fileList = res.data.data?.files; //附件
        this.filesHandle(fileList);
        this.form.billDate = timeFormatDate(res.data.data?.billDate);

        this.form.budget = res.data.data?.budgetExecutionType; //预算执行

        this.form.applicantId = res.data.data?.applicantId;
        this.form.originalLoan = res.data.data?.originalLoan;
        this.form.reasons = res.data.data?.reasons;
        this.expenseList = res.data.data?.detailsVos; //报销明细
        //预算执行
        this.budgetList.map(item => {
          if (item.value == res.data.data?.budgetExecutionType) {
            this.form.budgetName = item.label;
          }
        });

        // 费用项目归属
        this.form.costAttributionId = res.data.data?.costAttributionId;
        this.form.costAttributionName = res.data.data?.costAttributionName;
        this.form.projectNo = res.data.data?.projectNo;

        this.form.loanBillId = res.data.data?.loanBillId; // 兼容借款单
        this.form.relateApprovalNo = res.data.data?.relateApprovalNo; //关联审批单
      }
      if (this.$route.query?.type == 3) {
        const res = await billsApi.applicationInfo(getId);
        this.form.billType = res.data.data.billType;
        this.billTypeList.map(item => {
          if (item.value == this.form.billType) {
            this.form.billTypeName = item.label;
          }
        });

        const contactType = res.data.data.contactType;

        await this.contactType(); // 类型接口数据

        let o = this.contactTypesList.find(itm => itm.key == contactType);
        this.form.contactUnitTypeName = o.value; // 类型名字

        this.handleChange(this.form.contactUnitTypeName);

        this.form.contactUnitType = res.data.data.contactType; //单位标识
        this.form.contactCode = res.data.data.contactCode; //单位Code
        this.form.contactCompany = res.data.data.contactCompany; //单位Company

        this.form.budget = res.data.data?.budgetExecutionType; //预算执行

        let budge = this.budgetList.find(itm => itm.value == res.data.data?.budgetExecutionType);
        this.form.budgetName = budge.label;

        // 费用项目归属
        this.form.costAttributionId = res.data.data?.costAttributionId;
        this.form.costAttributionName = res.data.data?.costAttributionName;
        this.form.projectNo = res.data.data?.projectNo;

        //关联单据
        let rela = this.relationBillTypeList.find(itm => itm.value == res.data.data?.relationBillType);
        this.form.relationBillTypeName = rela?.label;

        let fileList = res.data.data?.files; //附件
        this.filesHandle(fileList);
        this.form.relationBillNo = res.data.data?.relationBillNo; //单据号
        this.form.remark = res.data.data.remark; //付款事由

        this.payee = res.data.data?.payeeVos; //收款人
        this.payList = res.data.data?.detailsVos; //付款申请

        this.changeContact(res.data.data.contactCode, 'edit'); // 兼容编辑
      }
      if (this.$route.query?.type == 4) {
        const res = await billsApi.travelExpensesReimbursementDetail(getId);
        this.form.budget = res.data.data?.budget; //预算执行
        //预算执行
        this.budgetList.map(item => {
          if (item.value == res.data.data?.budget) {
            this.form.budgetName = item.label;
          }
        });
        // 费用项目归属
        this.form.costAttributionId = res.data.data?.attributionId;
        this.form.costAttributionName = res.data.data?.attributionName;
        this.form.projectNo = res.data.data?.projectNo;

        let fileList = res.data.data?.files; //附件
        this.filesHandle(fileList);
        this.form.reasons = res.data.data?.reasons; //出差事由
        this.travelPayee = res.data.data?.payees; //收款人
        this.travelList = res.data.data?.items; //报销明细
        this.form.relateApprovalNo = res.data.data?.relateApprovalNo; //出差审批单
        this.form.loanBillId = res.data.data?.loanCode;
        this.form.loanCode = res.data.data?.loanCode; // 兼容差旅回显
      }
      if (this.$route.query?.type == 5) {
        const res = await billsApi.receiveDetail(getId);
        let fileList = res.data.data?.files; //附件
        this.filesHandle(fileList);
        this.form.budget = res.data.data?.budget; //预算执行
        // //预算执行
        this.budgetList.map(item => {
          if (item.value == this.form.budget) {
            this.form.budgetName = item.label;
          }
        });
        // 费用项目归属
        this.form.costAttributionId = res.data.data?.attributionId;
        this.form.costAttributionName = res.data.data?.attributionName;
        this.form.projectNo = res.data.data?.projectNo;

        this.form.drawAmount = res.data.data?.drawAmount;
        this.form.reasons = res.data.data?.reasons;
      }
    },
    // 读信息返回
    readTypeInfo() {
      let type = this.approvalType;
      let memory = this.$store.state.infoData?.sendPickerName;

      if (memory && type == 1) {
        let params = JSON.parse(JSON.stringify(this.$store.state.infoData));
        this.form = { ...params.form };
        this.borrowList = params.borrowList;
        this.payee = params.payee;
        this.sendType = params.sendType;
        this.sendInd = params.sendInd;
        this.sendPickerName = params.sendPickerName;
        this.$store.commit('setInfoData', {});
        return;
      }

      if (memory && type == 2) {
        let params = JSON.parse(JSON.stringify(this.$store.state.infoData));
        this.form = params.form;
        this.expenseList = params.detailsReqDtos;
        this.payee = params.payeeReqDtos;
        this.sendType = params.sendType;
        this.sendInd = params.sendInd;
        this.sendPickerName = params.sendPickerName;
        this.$store.commit('setInfoData', {});
        return;
      }

      if (memory && type == 3) {
        let params = JSON.parse(JSON.stringify(this.$store.state.infoData));
        this.form.contactCompany = null;
        this.form.contactUnitTypeName = null;
        this.form = { ...params.form };
        this.payList = params.detailsReqDtos;

        this.sendType = params.sendType;
        this.sendInd = params.sendInd;
        this.sendPickerName = params.sendPickerName;
        this.form.contactType = params.contactType;

        this.handleChange(params.form.contactUnitTypeName);
        this.form.contactUnitTypeName = params.form.contactUnitTypeName;
        this.form.contactCompany = params.form.contactCompany;
        this.form.contactCode = params.form.contactCode; // 付款单 往来单位 需要回显赋值给contactCode
        this.form.contactUnitType = params.form.contactUnitType;

        this.payee = params.payeeReqDtos;
        this.changeContact(params.form.contactCode, 'edit'); // 兼容编辑

        this.$store.commit('setInfoData', {});
        return;
      }

      if (memory && type == 4) {
        let params = JSON.parse(JSON.stringify(this.$store.state.infoData));
        this.form = params.form;
        this.travelList = params.items;
        this.travelPayee = params.payees;
        this.sendType = params.sendType;
        this.sendInd = params.sendInd;
        this.sendPickerName = params.sendPickerName;
        this.$store.commit('setInfoData', {});
        return;
      }

      if (memory && type == 5) {
        let params = JSON.parse(JSON.stringify(this.$store.state.infoData));
        this.form = params.form;
        this.sendType = params.sendType;
        this.sendInd = params.sendInd;
        this.sendPickerName = params.sendPickerName;
        this.$store.commit('setInfoData', {});
        return;
      }
    }
  },
  watch: {
    routerId(val) {
      if (val) {
        this.getDetail(this.routerId);
      }
    }
  },
  async created() {
    if (this.$route.query.id != undefined) {
      this.routerId = this.$route.query?.id;
    }

    this.approvalType = parseInt(this.$route.query?.type);
    this.title = this.approvalType === 1 ? '借款审批单' : this.approvalType === 2 ? '费用报销单' : this.approvalType === 3 ? '付款申请单' : this.approvalType === 4 ? '差旅报销单' : '领款单';
    const user = JSON.parse(localStorage.getItem('user'));

    this.getKitId(user); // 获取模板modelId

    this.checkProjId();

    this.getDropList();

    await this.getUserInfo();

    this.queryProjectApprovalList();

    this.approvalType != 3 && (await this.getStaffDetails()); // type:3 银行信息带出来

    this.reqApprovalOldListIds();

    await this.contactType('add');

    // 回显
    this.readTypeInfo();

    // 从别的地方选文件进入app
    window['uploadFileH5'] = result => {
      if (result) {
        let fileList = [result].map(item => ({
          ...item,
          key: uuidv4(),
          name: item.fileName.indexOf('.') > -1 ? item.fileName : item.fileName + item.url.slice(item.url?.lastIndexOf('.'))
        }));
        if (this.fileList.length > 0) {
          if (!this.checkSameFileName(this.fileList, result)) {
            this.fileList = [...this.fileList, ...fileList];
          }
        } else {
          this.fileList = fileList;
        }
      }
    };
  }
};
</script>
<style lang="less" scoped>
.container {
  width: 100vw;
  height: 100vh;
  overflow: auto;
  padding-bottom: 1.81rem;
  background: #f9f9f9;
  position: relative;
  padding-top: 1.71rem;
}

.apply-tab {
  width: 10rem;
  height: 1.71rem;
  background: #ffffff;
  position: fixed;
  z-index: 99;
  padding-left: 0.43rem;
  line-height: 1.71rem;
  top: 0;
  left: 0;
}

.apply-tab div {
  font-size: 0.48rem;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.peopleDeatail {
  width: 9.25rem;
  background: white;
  overflow: auto;
  padding: 0.2rem;
  margin: 0.43rem auto;
  box-shadow: 0rem 0.05rem 0.11rem 0rem #f2f3f5;
  border-radius: 0.21rem;

  .title_header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .add_item {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
}

/deep/ textarea {
  height: 30px !important;
}

/deep/ .detail_title {
  font-family: Source Han Sans CN !important;
  font-weight: 700 !important;
  color: #333333 !important;
  font-size: 16px !important;
  line-height: 16px !important;
}

.btn {
  border-radius: 0.15rem;
  margin-left: 15px;
  border: 1px solid;
  font-size: 12px;
  width: 80px;
  border-color: #1e89ff;
  border-radius: 13px;
  background: white;
  color: #1e89ff;
}

.button_box {
  width: 100vw;
  height: 1.81rem;
  position: fixed;
  left: 0;
  bottom: 0;
  flex-flow: row nowrap;
  justify-content: space-between;
  background: #ffffff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  box-shadow: 0px -2px 4px 0px #efefef;
}

.button_box .button1 {
  width: 3.99rem;
  height: 1.17rem;
  background: #ffffff;
  border-radius: 0.21rem;
  border: 0.03rem solid #666666;
  margin: 0px 10px;
}

.button_box .button2 {
  width: 3.99rem;
  height: 1.17rem;
  background: #1584ff;
  border-radius: 0.21rem;
  color: #ffffff;
  box-shadow: 0rem 0.05rem 0.21rem 0rem #80bcff;
  border: none;
  margin: 0px 10px;
}

.annex-name {
  display: flex;
  align-items: center;
}

.annex-button {
  width: 1.41rem;
  background: #ffffff;
  border-radius: 0.11rem;
  border: 0.03rem solid #1584ff;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #1584ff;
  text-align: center;
  line-height: 0.7rem;
  height: 0.7rem;
}

.oa-cb {
  padding: 0.4rem;
}

.cb-li {
  padding: 5px;
}

// 流程
.process-start {
  display: flex;
  justify-content: space-between;
  position: relative;
}

.circular {
  width: 0.3rem;
  height: 0.3rem;
  background-color: #d9d9d9;
  border-radius: 50%;
}

.strip {
  width: 0.05rem;
  height: 1.5rem;
  margin-left: 0.12rem;
  background-color: #d9d9d9;
}

.process-hide {
  visibility: hidden;
}

.select-number {
  height: 0.45rem;
  font-size: 0.32rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #888888;
  line-height: 0.45rem;
  min-width: 2rem;
}

.approve-alreadySelect {
  display: flex;
  flex-wrap: wrap;
  margin-left: 0.2rem;
  width: 6rem;
  flex-direction: row-reverse;
}

.member-plus {
  border-radius: 4px;
  font-size: 1.07rem;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 0;
}

.approve-list {
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  width: 4.8rem;
}

.selected-member {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1rem;
  position: relative;
  margin-right: 0.2rem;
  margin-bottom: 0.3rem;
}

.member-img {
  width: 1rem;
  height: 1rem;
  border-radius: 4px;
}

.member-delete {
  color: white;
  background: red;
  border-radius: 0.4rem;
  width: 0.4rem;
  height: 0.4rem;
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -0.1rem;
  left: 0.7rem;
}

.member-name {
  height: 0.37rem;
  font-size: 0.27rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 0.37rem;
  text-align: center;
  font-size: 12px;
  word-break: break-word;
}

.rtpay {
  color: #1584ff;
  font-size: 12px;
}
</style>
